import { type ElementNode } from "@solidtv/solid";
import { Row } from "@solidtv/solid/primitives";
import { Show } from "solid-js";
import FocusableButton from "./FocusableButton";
import theme from "theme";

interface EntityHeroProps {
  title: string;
  durationText?: string;
  tags?: string;
  description: string;
  hasPlayableSource: boolean;
  isLive?: boolean;
  onPlay: () => void;
  onClose: () => void;
  onDown?: () => boolean;
  actionRef?: (el: ElementNode) => void;
}

export default function EntityHero(props: EntityHeroProps) {
  return (
    <view x={120} y={180} width={800} zIndex={110}>
      <text fontSize={72} fontWeight="bold" width={800} maxLines={2} color={theme.textPrimary} contain="both" height={160}>
        {props.title}
      </text>

      <Row y={160} gap={20}>
        <Show when={props.durationText}>
          <text fontSize={24} color={theme.textSecondary}>
            {props.durationText}
          </text>
        </Show>
        <Show when={props.tags}>
          <text fontSize={24} color={theme.textSecondary}>
            {props.tags}
          </text>
        </Show>
      </Row>

      <text y={210} fontSize={28} width={800} maxLines={3} lineHeight={40} color={0xddddddff} contain="width">
        {props.description}
      </text>

      <Row
        ref={props.actionRef}
        y={350}
        gap={30}
        height={90}
        onDown={props.onDown}
      >
        <Show when={props.hasPlayableSource}>
          <FocusableButton autofocus onEnter={props.onPlay}>
            {props.isLive ? "Watch Live" : "Play"}
          </FocusableButton>
        </Show>
        <FocusableButton autofocus={!props.hasPlayableSource} onEnter={props.onClose}>
          Back
        </FocusableButton>
      </Row>
    </view>
  );
}
